import React, { useEffect, useState } from 'react';
import {
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  ListItemText,
  Skeleton,
  Tooltip,
  TooltipProps,
} from '@mui/material';
import { RootState } from '../../state/store';
import { toggleState } from './formSlice';

import { KeyboardArrowDown } from '@mui/icons-material';
import {
  Segment,
  SmallTypography,
  StateContainer,
} from '../../pages/ScenarioCreation/components/SegmentSelection/DynamicContents.Styled';
import { BottlerIcon } from '../../assets/images/UI-dashboard';
import { BrandMenuContainer, MenuContainer } from '../filters/FilterDropDown.Styled';
import { setSelectedBrandValues } from '../../features/brand/brandSlice';
import { useAppDispatch, useAppSelector } from '../../state/hooks';
import { fetchKpiCalculation } from '../../features/inputKpi/inputKpiSlice';
import { styled } from '@mui/material/styles';
import { StyledCheckbox } from '../../utils/commonStyles.Styled';
import { hideLoader, showLoader } from '../../features/ui/loaderSlice';
import { MoreOrLessText } from './FormStyles.Styled';

export const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: '#f5f5f5',
    color: '#000',
    boxShadow: theme.shadows[1],
    borderRadius: '4px',
    padding: '8px',
    maxWidth: '200px',
    height: '20px',
    alignItems: 'center',
    display: 'flex',
  },
  [`& .MuiTooltip-arrow`]: {
    color: '#f5f5f5',
  },
}));

const StateSelection: React.FC = () => {
  const dispatch = useAppDispatch();
  const { selectedAvailablePack, selectedSegment } = useAppSelector((state: RootState) => state.form);
  const statesToShow = useAppSelector((state: RootState) => state.filters.enabledKeys.state);
  const { brands, selectedBrands } = useAppSelector((state: RootState) => state.brand);
  const { current_tab } = useAppSelector((state: RootState) => state.inputKpi);
  const filtersState = useAppSelector((state: RootState) => state.filters);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showMore, setShowMore] = useState(false);

  const handleSelectState = (stateName: string) => {
    dispatch(toggleState(stateName));
  };

  useEffect(() => {
    if (selectedBrands.length !== 0) {
      const payload = {
        bottler: filtersState.enabledKeys.bottler,
        state: filtersState.enabledKeys.state,
        category: filtersState.enabledKeys.category,
        pack_segment: [`${selectedSegment}`],
        pack_size: [`${selectedAvailablePack}`],
        brand: selectedBrands,
      };
      if (current_tab === 'Launch' || current_tab === 'Replace') {
        return;
      } else {
        dispatch(
          fetchKpiCalculation({
            ...payload,
            intervention_type: current_tab === 'Pricing & Distribution' ? 'Pricing' : current_tab,
          }),
        );
      }
    }
  }, [brands, dispatch]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = async () => {
    setAnchorEl(null);

    const payload = {
      bottler: filtersState.enabledKeys.bottler,
      state: filtersState.enabledKeys.state,
      category: filtersState.enabledKeys.category,
      pack_segment: [`${selectedSegment}`],
      pack_size: [`${selectedAvailablePack}`],
      brand: selectedBrands,
    };

    if (current_tab === 'Launch') {
      return;
    } else {
      await dispatch(showLoader());
      await dispatch(
        fetchKpiCalculation({
          ...payload,
          intervention_type: current_tab === 'Pricing & Distribution' ? 'Pricing' : current_tab,
        }),
      );
      await dispatch(hideLoader());
    }
  };

  const handleBrandChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = event.target;

    const updateSelectedBrands = new Promise<void>((resolve) => {
      dispatch(
        setSelectedBrandValues(checked ? [...selectedBrands, value] : selectedBrands.filter((item) => item !== value)),
      );
      resolve();
    });

    await updateSelectedBrands;
  };

  return (
    <Grid style={{ position: 'relative' }}>
      <StateContainer>
        <Grid
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Grid>
            <SmallTypography>States</SmallTypography>
          </Grid>
        </Grid>
        <Grid>
          {false ? (
            <Grid style={{ display: 'flex' }}>
              {['1', '2', '3'].map((ele) => (
                <Skeleton key={ele} style={{ marginRight: '10px' }} variant="rectangular" width={60} height={23.34} />
              ))}
            </Grid>
          ) : (
            <Grid
              style={{
                display: 'flex',
                marginTop: '5px',
                flexWrap: 'wrap',
                width: '100%',
                flexDirection: 'row',
              }}
            >
              {statesToShow && (
                <>
                  {(showMore ? statesToShow : statesToShow.slice(0, 5)).map((text, index) => (
                    <Segment key={index} selected={statesToShow.includes(text)} onClick={() => handleSelectState(text)}>
                      {text}
                    </Segment>
                  ))}

                  {!showMore && statesToShow.length > 5 && (
                    <MoreOrLessText onClick={() => setShowMore(true)}>More States..</MoreOrLessText>
                  )}

                  {showMore && statesToShow.length > 5 && (
                    <MoreOrLessText onClick={() => setShowMore(false)}>Less States..</MoreOrLessText>
                  )}
                </>
              )}
            </Grid>
          )}
        </Grid>
      </StateContainer>

      <Grid
        style={{
          display: 'flex',
          justifyContent: 'start',
          alignContent: 'start',
          alignItems: 'start',
          whiteSpace: 'nowrap',
          marginLeft: '13%',
          position: 'absolute',
          right: 2,
          top: 0,
        }}
      >
        <Grid
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography
            style={{
              color: '#E81C0E',
              fontSize: '12px',
              lineHeight: '13.35px',
              fontWeight: 600,
              whiteSpace: 'nowrap',
              verticalAlign: 'center',
              cursor: 'pointer',
            }}
          >
            Brands
          </Typography>
          <IconButton
            style={{
              padding: '0px',
            }}
            onClick={handleClick}
          >
            <KeyboardArrowDown style={{ color: '#000000' }} />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            PaperProps={{
              style: {
                width: '186px',
                fontSize: '9px',
                padding: '0px',
              },
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            MenuListProps={{
              style: {
                padding: 0,
              },
            }}
          >
            <Grid
              style={{
                background: '#DF2020',
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
                height: 26,
              }}
            >
              <Typography
                style={{
                  color: 'white',
                  fontSize: '10px',
                  lineHeight: '13.35px',
                  fontWeight: 600,
                }}
              >
                Brand
              </Typography>
              <Typography
                style={{
                  color: 'white',
                  fontSize: '10px',
                  lineHeight: '13.35px',
                  fontWeight: 600,
                }}
              >
                Volume Mix
              </Typography>
            </Grid>

            <MenuContainer
              style={{
                maxHeight: '120px',
                overflowY: 'auto',
              }}
            >
              <BrandMenuContainer style={{ padding: '0px' }}>
                {Object.keys(brands).map((name) => (
                  <MenuItem
                    style={{
                      padding: '5px',
                      display: 'flex',
                      justifyContent: 'space-between',
                      minHeight: 'auto',
                      paddingTop: '8px',
                      paddingBottom: '8px',
                    }}
                    key={name}
                    value={name}
                    onClick={(event) => {
                      const isChecked = selectedBrands.includes(name);
                      const eventTarget = {
                        target: { value: name, checked: !isChecked },
                      } as React.ChangeEvent<HTMLInputElement>;
                      handleBrandChange(eventTarget);
                    }}
                  >
                    <Grid style={{ display: 'flex' }}>
                      <StyledCheckbox
                        style={{ padding: '0px', marginTop: '5px' }}
                        value={name}
                        checked={selectedBrands.includes(name)}
                        onChange={handleBrandChange}
                        onClick={(e) => e.stopPropagation()}
                      />
                      <ListItemText
                        style={{
                          padding: '0px',
                          marginTop: '5px',
                        }}
                        primary={name}
                        onClick={(event) => {
                          event.stopPropagation();
                          const isChecked = selectedBrands.includes(name);
                          const eventTarget = {
                            target: { value: name, checked: !isChecked },
                          } as React.ChangeEvent<HTMLInputElement>;
                          handleBrandChange(eventTarget);
                        }}
                      />
                    </Grid>
                    <Typography
                      style={{
                        color: 'black',
                        fontSize: '9px',
                        lineHeight: '13.35px',
                        fontWeight: 500,

                        textAlign: 'center',
                        marginRight: '5%',
                      }}
                    >
                      {brands[name]}%
                    </Typography>
                  </MenuItem>
                ))}
              </BrandMenuContainer>
            </MenuContainer>

            <Grid
              style={{
                position: 'relative',
                background: 'white',
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
                height: '26px',
                width: '100%',
                boxShadow: '0px 0px 4px 0px #00000021',
              }}
            >
              <Typography
                style={{
                  color: '#DF2020',
                  fontSize: '8px',
                  lineHeight: '13.35px',
                  fontWeight: 600,

                  marginLeft: '20px',
                }}
              >
                Total
              </Typography>
              <Typography
                style={{
                  color: '#DF2020',
                  fontSize: '10px',
                  lineHeight: '13.35px',
                  fontWeight: 600,

                  marginLeft: '20px',
                }}
              >
                100%
              </Typography>
            </Grid>
          </Menu>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default StateSelection;
